'use client';

import { useEffect } from 'react';
import Script from 'next/script';
import { useLocationStore } from 'stores/location';
import LocationDrawer from '../location-drawer';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  isUpdatingLocation?: boolean;
  googleMapKey?: string;
};

export default function LocationAutoCompleteDrawer({
  isOpen,
  onClose,
  isUpdatingLocation = false,
  googleMapKey,
}: Props) {
  const setLoadingGoogleMap = useLocationStore((state) => state.setLoadingGoogleMap);

  /**
   *
   * We use this effect to check if the Google Maps script has already been loaded
   * and if the drawer is open. This ensures the `LocationDrawer` receives the correct
   * `isScriptLoaded` prop in case the script was cached or previously loaded,
   * avoiding redundant loading logic and ensuring the Places API is ready.
   */

  useEffect(() => {
    if (typeof window !== 'undefined' && window.google?.maps && isOpen) {
      setLoadingGoogleMap(true);
    }
  }, [isOpen, setLoadingGoogleMap]);

  return (
    <>
      <Script
        src={`https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=places,marker&loading=async`}
        strategy="lazyOnload"
        id="google-maps-script"
        onLoad={() => setLoadingGoogleMap(true)}
      />

      <LocationDrawer isOpen={isOpen} isUpdatingLocation={isUpdatingLocation} onClose={onClose} />
    </>
  );
}
